var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget-section"},_vm._l((_vm.widgetList),function(widget){return _c('WidgetButton',{key:widget.type,attrs:{"widget":widget,"parent-id":_vm.parentId}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }